import * as React from 'react'
import {useGlobalBus} from '@/services/global-bus'
import {useState} from 'react'
import './Dialog.style'

export function Dialog() {
    const [dialogShow, setDialogShow] = useState<boolean>(false)
    const [subTitle, setSubTitle] = useState<string>('subtitle')
    const [title, setTitle] = useState<string>('title')
    const [fn, setFn] = useState<any>()
    const [buttonStyle, setButtonStyle] = useState<string[]>(['checkBtn', 'cancelBtn'])

    useGlobalBus({
        dialogInfo: (info) => {
            if (info.isShow) {
                setDialogShow(true)
                setTitle(info.title)
                setSubTitle(info.subTitle)
                setFn(info.fn)
                if (info.ButtonStyle && info.ButtonStyle.length === 2) {
                    setButtonStyle(info.ButtonStyle)
                }
            } else {
                setDialogShow(false)
            }
        }
    })

    if (dialogShow) {
        return (
            <div className="DialogMask">
                <div className="DialogWrap">
                    <div className="DialogContent">
                        <div className="Dialog_title">{title}</div>
                        <p className="Dialog_subTitle">
                            {subTitle}
                        </p>

                        <div className="Dialog_btn">
                            {fn && fn.map((v) => (
                                <button
                                    className={v.tag === 'success' ? buttonStyle[0] : buttonStyle[1]}
                                    key={v.tag}
                                    onClick={() => v.fn()}
                                >{v.name}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            </div>)
    } else {
        return null
    }
}



// WEBPACK FOOTER //
// ./src/components/Dialog/Dialog.tsx